const getUrl = () => {
  let backendAddress;
  if (process.env.NODE_ENV === "production") {
    backendAddress = `https://www.rhinologyjournal.com/rrs-backend`;
    //backendAddress = `http://staging.slagalica-online.com:9098`;
    // backendAddress = `https://rhinology-journal.herokuapp.com`;
  } else {
    backendAddress = `https://www.rhinologyjournal.com/rrs-backend`;
    // backendAddress = `http://staging.slagalica-online.com:9098`;
    // backendAddress = `https://rhinology-journal.herokuapp.com`;
  }
  return `${backendAddress}/api`;
};
const Endpoints = {
  AUTHENTICATE: getUrl() + "/authenticate",
  REGISTRATION: getUrl() + "/register",
  RESET_PASSWORD: getUrl() + "/reset-password",
  LOGOUT: getUrl() + "/user/logout",
  USER: getUrl() + "/user",
  USER_PROFILE: getUrl() + "/users/profile",
  COUNTRY_LIST: getUrl() + "/countries",
  ARTICLE: getUrl() + "/article",
  TICKET: getUrl() + "/ticket",
};

export default Endpoints;
